export default __webpack_public_path__ + "static/gestion-5a20c428071493d446ebe07014110cb6.png";